export default __webpack_public_path__ + "static/media/icon_paypal.24182d78.svg";